(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-main-picker-test"] && !Shopify.designMode) return;
  try {
    if (!window.__flavoThumbsBound) {
    window.__flavoThumbsBound = true;

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-flavor-thumb]');
      if (!button) return;

      var wrapper = button.closest('[data-flavor-thumbs]');
      if (!wrapper) return;

      var select = document.getElementById(wrapper.getAttribute('data-select-id'));
      if (!select) return;

      var valueId = button.getAttribute('data-option-value-id');
      var option = select.querySelector('option[data-option-value-id="' + valueId + '"]');
      if (!option) return;

      select.value = option.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));

      wrapper.querySelectorAll('[data-flavor-thumb]').forEach(function (btn) {
        btn.classList.toggle('is-selected', btn === button);
      });
    });

    document.addEventListener('change', function (event) {
      var select = event.target;
      if (!select.matches('.variant-option__select')) return;

      var wrapper = select.closest('.variant-option--dropdowns');
      if (!wrapper) return;
      var thumbsWrapper = wrapper.querySelector('[data-flavor-thumbs]');
      if (!thumbsWrapper) return;

      var selectedOption = select.options[select.selectedIndex];
      var valueId = selectedOption ? selectedOption.getAttribute('data-option-value-id') : null;

      thumbsWrapper.querySelectorAll('[data-flavor-thumb]').forEach(function (btn) {
        btn.classList.toggle('is-selected', btn.getAttribute('data-option-value-id') === valueId);
      });
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    if (!window.__flavoThumbsBound) {
    window.__flavoThumbsBound = true;

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-flavor-thumb]');
      if (!button) return;

      var wrapper = button.closest('[data-flavor-thumbs]');
      if (!wrapper) return;

      var select = document.getElementById(wrapper.getAttribute('data-select-id'));
      if (!select) return;

      var valueId = button.getAttribute('data-option-value-id');
      var option = select.querySelector('option[data-option-value-id="' + valueId + '"]');
      if (!option) return;

      select.value = option.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));

      wrapper.querySelectorAll('[data-flavor-thumb]').forEach(function (btn) {
        btn.classList.toggle('is-selected', btn === button);
      });
    });

    document.addEventListener('change', function (event) {
      var select = event.target;
      if (!select.matches('.variant-option__select')) return;

      var wrapper = select.closest('.variant-option--dropdowns');
      if (!wrapper) return;
      var thumbsWrapper = wrapper.querySelector('[data-flavor-thumbs]');
      if (!thumbsWrapper) return;

      var selectedOption = select.options[select.selectedIndex];
      var valueId = selectedOption ? selectedOption.getAttribute('data-option-value-id') : null;

      thumbsWrapper.querySelectorAll('[data-flavor-thumb]').forEach(function (btn) {
        btn.classList.toggle('is-selected', btn.getAttribute('data-option-value-id') === valueId);
      });
    });
  }
  } catch(e) { console.error(e); }
})();

})();
